import {AfterViewInit, Component, HostListener, Input, OnInit, signal} from '@angular/core';

@Component({
  selector: 'homey-sticky-footer',
  templateUrl: './sticky-footer.component.html',
  host: {
    class: 'sticky bottom-0 left-0 right-0 bg-white py-2 -mx-4 px-4 transition-shadow duration-300 w-100vw z-20',
    '[style.box-shadow]': '!atBottom() ? "0 -3px 3px rgba(0,0,0,0.08)" : "none"',
    '[style.clip-path]': '"inset(-10px 0px 0px 0px)"',
    '[class.shadow-none]': 'atBottom()',
    '(window:scroll)': `!scrollContainer && onWindowScroll()`,
    '(scroll)': `scrollContainer && onContainerScroll($event)`
  }
})
export class StickyFooterComponent implements OnInit, AfterViewInit {
  /** The scroll container selector — default: window */
  @Input() scrollContainer?: HTMLElement;
  atBottom = signal(false);

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(_event?: Event) {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    if (!this.scrollContainer) {
      const scrollTop = window.scrollY;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = window.innerHeight;
      this.atBottom.set(scrollTop + clientHeight >= scrollHeight - 1);
    }
  }

  ngOnInit() {
    this.onWindowScroll();
    setTimeout(() => this.onWindowScroll(), 500);
  }

  ngAfterViewInit() {
    this.onWindowScroll();
  }

  onContainerScroll(event: Event) {
    const target = event.target as HTMLElement;
    this.atBottom.set(target.scrollHeight - target.scrollTop <= target.clientHeight + 1);
  }
}
